import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SerieVideoForm, useSerieVideo } from '@/features/series-video-management';
import { Skeleton } from '@/shared/ui/atoms';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/series/$serieId/videos/$videoId/')({
  component: SerieVideoEditPage,
});

/** Página de edição de Vídeo. */
export function SerieVideoEditPage() {
  const { t } = useTranslation('series');
  const { serieId: serieIdParam, videoId } = Route.useParams();
  const serieId = Number(serieIdParam);
  const navigate = useNavigate();

  const { video, isLoading } = useSerieVideo(Number(videoId));

  const goBack = () =>
    void navigate({ to: '/series/$serieId/videos', params: { serieId: serieIdParam } });

  return (
    <div className="flex flex-col gap-xxs">
      <PageHeader
        title={t('videos.form.editTitle')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series">{t('videos.breadcrumb.series')}</Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series/$serieId/videos" params={{ serieId: serieIdParam }}>
                {t('videos.breadcrumb.videos')}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('videos.form.editTitle')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      {isLoading ? (
        <Skeleton className="h-[480px] w-full rounded-sm" />
      ) : (
        <SerieVideoForm
          serieId={serieId}
          video={video ?? null}
          onSaved={goBack}
          onCancel={goBack}
        />
      )}
    </div>
  );
}
